import LoadingPlanet from "./loading-planet";

export default LoadingPlanet